import { Actions, Module, Mutations, Getters } from 'vuex-smart-module'

import type { AppealTopicBlock, MailClaimSendBody } from '@/api'

import { AppealsService } from '@/api'

export class FeedbackState {}

export class FeedbackGetters extends Getters<FeedbackState> {}

export class FeedbackMutations extends Mutations<FeedbackState> {}

export class FeedbackActions extends Actions<FeedbackState, FeedbackGetters, FeedbackMutations, FeedbackActions> {
  async getFeedbackTopics(): Promise<AppealTopicBlock> {
    return await AppealsService.getAppealsTopics()
  }

  async sendFeedback(form: MailClaimSendBody): Promise<void> {
    return await AppealsService.sendAppeal(form)
  }
}

export const feedback = new Module<FeedbackState, FeedbackGetters, FeedbackMutations, FeedbackActions>({
  state: FeedbackState,
  getters: FeedbackGetters,
  mutations: FeedbackMutations,
  actions: FeedbackActions,
})
